import jwt from 'jsonwebtoken';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { COOKIE } from '../constants';

export const MERCHANT_ROLES = {
  MERCHANT: 'merchant',
  MERCHANT_MANAGER: 'merchant-manager',
};

export type MerchantState = {
  granted: boolean;
  role: string;
};

export const decodeMerchant = (accessToken) => {
  const { role }: any = jwt.decode(accessToken);
  const granted =
    role === MERCHANT_ROLES.MERCHANT ||
    role === MERCHANT_ROLES.MERCHANT_MANAGER;
  return { role, granted };
};

const useMerchant = (defaultMerchant = { granted: false, role: '' }) => {
  const [merchant, setMerchant] = useState<MerchantState>(defaultMerchant);
  const [cookies] = useCookies([COOKIE.ACCESS_TOKEN]);
  const router = useRouter();

  const redirectAway = () => {
    router.push('/shop');
  };

  useEffect(() => {
    const token = cookies[COOKIE.ACCESS_TOKEN];
    if (!token) {
      redirectAway();
    }
    try {
      const { granted, role } = decodeMerchant(token);
      if (!granted) {
        redirectAway();
      }
      setMerchant({ granted, role });
    } catch (err) {
      redirectAway();
    }
  }, [merchant.granted, merchant.role]);

  return merchant;
};

export default useMerchant;
